//TODO: Develop way to retrieve data and stay up to date
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.AdvisorySource = new Class({
    Extends: OCS.Viewer.Classes.VectorSource,
    class_name: "AdvisorySource",
    advisories: {},
    advisory_features: {},
    date_obj: null,
    options: {
        init: {
            contour_delta: 5,
            contour_resolution: 100,
            interpolation_factor: 2
        },
        metadata: {
            source_type: 'Advisory',
            'filter_wfo_ids': true,
            'filtered_wfo_ids': OCS.Viewer.Config.advisory_info.filtered_wfo_ids,
            warning_types: null,
        }
    },
    time_update_timeout: null,
    bound_methods: {},
    initialize: function (ops) {
        this.parent(ops);

        // Register the source filters
        var advmngr = OCS.Viewer.Functions.get_advisory_manager();
        advmngr.register(this.get_id(), this.options.metadata);
        advmngr.addEvent('advisory_update', this.get_adv_data.bind(this));
        this.bound_methods.on_time_update = this.on_time_update.bind(this);
        this.bound_methods.on_advisory_updated = this.on_advisory_updated.bind(this);

    },
    get_adv_data: function () {
        var stale = this.get_dataset_obj().getOption('stale_threshold');
        var map_datetime = this.get_dateObj();
        var start = map_datetime.get_start_epoch_time() - stale;
        var end = map_datetime.get_end_epoch_time() + stale;
        var wfos_ids = [];
        var warning_types = [];
        if(this.options.metadata.filter_wfo_ids && this.options.metadata.filtered_wfo_ids.length) {
            wfos_ids = this.options.metadata.filtered_wfo_ids;
        }
        if(this.options.metadata.warning_types && this.options.metadata.warning_types.length) {
            warning_types = this.options.metadata.warning_types;
        }

        this.process_advisories(OCS.Advisories.Functions.retrieve_advisory_data(start, end, wfos_ids, warning_types));
    },
    add_feature_obj: function (feature_obj, feature_key) {
        this.parent(feature_obj);
        this.advisory_features[feature_key] = feature_obj;
    },
    process_advisories: function (data) {
        if (data && data.length) {
            var current = this.get_timestamp_epoch();
            data.each(function (adv_key) {
                var adv_obj = OCS.Advisories.Functions.get_adv(adv_key);
                if (!this.advisories[adv_key]) {
                    this.advisories[adv_key] = true;
                    adv_obj.addEvent('advisory_updated', this.bound_methods.on_advisory_updated);
                    adv_obj.addEvent('advisory_cancelled', this.bound_methods.on_advisory_updated);
                }
                this.process_advisory(current, adv_obj);
            }, this);
        }
    },
    process_advisory: function(current, adv_obj) {
        var prop = adv_obj.get_adv_event_at_time(current);
        var geom;
        if(prop) {
            if(adv_obj.options.properties.draw_type === "lat_lon") {
                geom = this.get_advisory_geometry(prop.get_geom_event_key());
                if(!geom) {
                    // Since we didn't get a geometry on this time, lets go back into the past and get the last one
                    var old_time = current;
                    while(!geom && old_time > 0) {
                        old_time = OCS.Advisories.Functions.get_previous_event_timestamp(adv_obj.adv_events, old_time);
                        if(old_time > 0) {
                            geom = this.get_advisory_geometry(adv_obj.get_adv_event_at_time(old_time).get_geom_event_key());
                        } else {
                            // We ran out of time, lets set it to a default
                            geom = false;
                        }
                    }
                }
                if(geom && geom.get_geometry) {
                    this.process_advisory_feature({
                        type: "Feature",
                        geometry: geom.get_geometry(),
                        properties: OCS.Utilities.combine_objects(adv_obj.options.properties, prop.options),
                        crs: geom.options.crs
                    });
                }

            }
            if(adv_obj.options.properties.draw_type === "zone") {
                var zone_feature = {};
                adv_obj.get_zone_ids(current).each(function(zone_id) {
                    geom = this.get_advisory_geometry(zone_id);
                    if(geom) {
                        zone_feature = adv_obj.get_zone_feature(zone_id, current);
                        if(geom.then) {
                            // We got back a promise
                            geom.addEvent('complete', function(res) {
                                if(res && res.result && res.result.length) {
                                    zone_feature.geometry = res.result[0].get_geometry();
                                    zone_feature.crs = res.result[0].options.crs;
                                    this.process_advisory_feature(zone_feature);
                                }
                            }.bind(this));
                            geom.start();
                        }
                        if(geom.get_geometry) {
                            zone_feature.geometry = geom.get_geometry();
                            zone_feature.crs = geom.options.crs;
                            this.process_advisory_feature(zone_feature);
                        }
                    }

                }.bind(this));
            }
        }

    },
    valueFromLonLat: function (mouse_position) {
        var vs_source = this.get_source();
        //var vs_source = source.getSource();
        //var mouse_position = ol.proj.transform(inLonLat, OCS.Viewer.Config.default_display_projection, OCS.Viewer.Config.default_projection);
        return vs_source.getFeaturesAtCoordinate(mouse_position);
    },
    clear_unused_features: function () {
        var current_adv_features = {};
        var start_time = this.date_obj.get_start_epoch_time();
        var current_time = this.date_obj.get_current_epoch_time();
        var end_time;

        Object.each(this.advisory_features, function (feature_obj, feature_key) {
            end_time = feature_obj.options.properties.ending_time;

            if (end_time && start_time > end_time) {
                // this means that the start of the map is past when this advisory is to have expired. Time to remove it.
                this.remove_feature_obj(feature_obj);
            } else {
                current_adv_features[feature_key] = feature_obj;
                if(!feature_obj.is_active(current_time)) {
                    feature_obj.reset_feature();
                }
            }
        }.bind(this));
        this.advisory_features = current_adv_features;
    },


    get_advisory_geometry: function(sid) {
        var geom = OCS.Geometry.Functions.getGeometryBySid(sid, OCS.Viewer.Config.default_projection);
        if(geom) {
            return geom;
        } else {
            if(sid.length < 10) {
                return OCS.Viewer.Functions.get_geometry_manager().request({method: "geometries", "id": sid, "projection": OCS.Viewer.Config.default_projection,
                    "simplify": OCS.Viewer.Config.default_adv_simplification,
                    max_ids_to_request: 500
                });
            } else {
                return false;
            }


        }
    },
    set_dateObj: function (dateObj) {
        if (!this.date_obj) {
            this.date_obj = dateObj;
            this.date_obj.addEvent('time_update', this.bound_methods.on_time_update);
            // Now that we have a datetime obj, go get the data
            this.get_adv_data();
        }
    },
    get_dateObj: function () {
        return this.date_obj;
    },
    get_timestamp_epoch: function () {
        return this.date_obj.get_current_epoch_time();
    },
    process_advisory_feature: function(adv_feature) {
        var adv_key = OCS.Advisories.Functions.get_adv_key(adv_feature.properties.nwso,adv_feature.properties.phenom,adv_feature.properties.significance,adv_feature.properties.etn, this.date_obj.get_utc_string_with_format(adv_feature.properties.issued_time, this.date_obj.options.year_format));
        var adv_zone_key = adv_key;
        if (adv_feature.properties.zone_id) {
            adv_zone_key = adv_key+"-"+adv_feature.properties.zone_id;
        }

        if (!this.advisory_features[adv_zone_key]) {
            var feature_obj = new OCS.Viewer.Classes.AdvisoryFeature();
            feature_obj.set_feature_from_geojson(adv_feature);
            if(feature_obj.create()) {
                feature_obj.addEvent('destroyed', this.remove_feature_obj.bind(this));
                feature_obj.set_adv_key(adv_key);
                var ol_feature = feature_obj.get_feature();
                if(ol_feature) {
                    this.add_feature_obj(feature_obj, adv_zone_key);
                }
            } else {
                feature_obj.delete();
                return false;
            }

        }

        this.advisory_features[adv_zone_key].set_feature_from_geojson(adv_feature);
        if(!this.advisory_features[adv_zone_key].is_active(this.get_timestamp_epoch())) {
            this.advisory_features[adv_zone_key].reset_feature();
        } else {
            this.advisory_features[adv_zone_key].set_active(true);
        }
    },
    on_advisory_updated: function(adv_obj) {
        adv_obj.get_geojson(this.get_timestamp_epoch()).features.each(this.process_advisory_feature, this);
        this.clear_unused_features();
    },
    on_time_update: function (time_obj) {
        if(this.time_update_timeout) {
            clearTimeout(this.time_update_timeout);
        }
        this.time_update_timeout = setTimeout(function() {
            this.time_update_timeout = null;
            this.get_adv_data();
            // Cleanup
            this.clear_unused_features();
        }.bind(this), 50);


    },
    destroy: function () {
        if(this.time_update_timeout) {
            clearTimeout(this.time_update_timeout);
            this.time_update_timeout = null;
        }
        this.parent();
    }
});
